import db from "@/database";

const find = () => {
  return db.maritalStatus.toArray();
};

export { find };
